import { styled } from "@mui/material"
import MenuItem from "@mui/material/MenuItem"

export const StyledMenuItem = styled(MenuItem)`
  width: 250px;
`
